module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "740px",
      "margin": "0 auto",
      "border": "1px solid",
      "box-shadow": "5px 5px 5px #888888"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "640px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('my-content', {
    attrs: {
      "val": _vm.contract.name
    },
    model: {
      value: (_vm.contract.name),
      callback: function($$v) {
        _vm.$set(_vm.contract, "name", $$v)
      },
      expression: "contract.name"
    }
  })], 1), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('my-content', {
    attrs: {
      "val": _vm.contract.year
    },
    model: {
      value: (_vm.contract.year),
      callback: function($$v) {
        _vm.$set(_vm.contract, "year", $$v)
      },
      expression: "contract.year"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.month
    },
    model: {
      value: (_vm.contract.month),
      callback: function($$v) {
        _vm.$set(_vm.contract, "month", $$v)
      },
      expression: "contract.month"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.day
    },
    model: {
      value: (_vm.contract.day),
      callback: function($$v) {
        _vm.$set(_vm.contract, "day", $$v)
      },
      expression: "contract.day"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("日")])], 1), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal"
    }
  }, [_vm._v("乙方：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Bname
    },
    model: {
      value: (_vm.contract.Bname),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Bname", $$v)
      },
      expression: "contract.Bname"
    }
  })], 1), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal"
    }
  }, [_vm._v("丙方：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Cname
    },
    model: {
      value: (_vm.contract.Cname),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Cname", $$v)
      },
      expression: "contract.Cname"
    }
  })], 1), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("售后服务")]), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('ol', {
    staticClass: "awlist8",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("客户服务")]), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 20pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BcontactsName
    },
    model: {
      value: (_vm.contract.BcontactsName),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BcontactsName", $$v)
      },
      expression: "contract.BcontactsName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 20pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("职务：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BcontactsPost
    },
    model: {
      value: (_vm.contract.BcontactsPost),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BcontactsPost", $$v)
      },
      expression: "contract.BcontactsPost"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 20pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("电话：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BcontactsTel
    },
    model: {
      value: (_vm.contract.BcontactsTel),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BcontactsTel", $$v)
      },
      expression: "contract.BcontactsTel"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 20pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("手机：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BcontactsPhone
    },
    model: {
      value: (_vm.contract.BcontactsPhone),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BcontactsPhone", $$v)
      },
      expression: "contract.BcontactsPhone"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 20pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BcontactsEmail
    },
    model: {
      value: (_vm.contract.BcontactsEmail),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BcontactsEmail", $$v)
      },
      expression: "contract.BcontactsEmail"
    }
  })], 1)])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("服务费及货款结算")]), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('ol', {
    staticClass: "awlist9",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_vm._m(49), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n                    甲乙双方同意就每月就上月交易完成订单的商品货款及服务费进行对账工作。双方数据核对一致后，甲方就上述商品实际交易货款扣除甲方服务费、甲方平台卖家服务费及其他应扣除费用后的款项余额与乙方结算。结算币种为\n                    (\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.currency),
      expression: "contract.currency"
    }],
    staticClass: "pointer",
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.contract.currency, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.contract, "currency", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pointer",
    attrs: {
      "for": "one"
    }
  }, [_vm._v("人民币")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.currency),
      expression: "contract.currency"
    }],
    staticClass: "pointer",
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.contract.currency, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.contract, "currency", "2")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pointer",
    attrs: {
      "for": "two"
    }
  }, [_vm._v("欧元")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.currency),
      expression: "contract.currency"
    }],
    staticClass: "pointer",
    attrs: {
      "type": "radio",
      "id": "three",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.contract.currency, "3")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.contract, "currency", "3")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pointer",
    attrs: {
      "for": "three"
    }
  }, [_vm._v("美元")]), _vm._v("\n                    )\n                ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方可通过委托以下账号以银行转账或电汇方式向乙方银行账号付款：")]), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 3pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("收款方名称：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.collectName
    },
    model: {
      value: (_vm.contract.collectName),
      callback: function($$v) {
        _vm.$set(_vm.contract, "collectName", $$v)
      },
      expression: "contract.collectName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 3pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("开户银行：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.bankName
    },
    model: {
      value: (_vm.contract.bankName),
      callback: function($$v) {
        _vm.$set(_vm.contract, "bankName", $$v)
      },
      expression: "contract.bankName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 3pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("账号：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.bankNum
    },
    model: {
      value: (_vm.contract.bankNum),
      callback: function($$v) {
        _vm.$set(_vm.contract, "bankNum", $$v)
      },
      expression: "contract.bankNum"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 3pt",
      "text-indent": "1pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Swift ID：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.swiftId
    },
    model: {
      value: (_vm.contract.swiftId),
      callback: function($$v) {
        _vm.$set(_vm.contract, "swiftId", $$v)
      },
      expression: "contract.swiftId"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方如需修改付款信息，应提前在对账结束前书面通知甲方。如乙方未能在上述期限内通知甲方，则乙方应承担甲方根据未修改的付款信息向乙方进行付款所发生的一切后果。")])]), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56)])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("保证金")]), _vm._v(" "), _vm._m(57), _vm._v(" "), _c('ol', {
    staticClass: "awlist10",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方同意向甲方指定账户缴存一定金额（以下称“保证金”）用于担保其对本协议的履行和遵守。乙方应当在签订本协议后【10】日内向甲方支付总计")]), _vm._v(" "), _c('my-content', {
    staticStyle: {
      "text-indent": "0pt"
    },
    attrs: {
      "val": _vm.contract.deposit
    },
    model: {
      value: (_vm.contract.deposit),
      callback: function($$v) {
        _vm.$set(_vm.contract, "deposit", $$v)
      },
      expression: "contract.deposit"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("元（币种以结算币种为准）的保证金。 甲方有权根据乙方经营情况随时调整保证金额度。 如本协议为续签协议，甲乙双方同意，乙方根据双方签署的原《技术服务协议》及与其项下附件、补充协议（统称“原协议”）缴存的保证金余额继续适用于本协议。")])], 1), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62)])]), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("期限和终止")]), _vm._v(" "), _vm._m(67), _vm._v(" "), _c('ol', {
    staticClass: "awlist15",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt -13.35pt",
      "text-indent": "2pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议有效期限为自签署之日起至")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.endYear
    },
    model: {
      value: (_vm.contract.endYear),
      callback: function($$v) {
        _vm.$set(_vm.contract, "endYear", $$v)
      },
      expression: "contract.endYear"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.endMonth
    },
    model: {
      value: (_vm.contract.endMonth),
      callback: function($$v) {
        _vm.$set(_vm.contract, "endMonth", $$v)
      },
      expression: "contract.endMonth"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.endDay
    },
    model: {
      value: (_vm.contract.endDay),
      callback: function($$v) {
        _vm.$set(_vm.contract, "endDay", $$v)
      },
      expression: "contract.endDay"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])], 1), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69)])]), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71)]), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "margin-left": "0pt",
      "width": "426.1pt"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "200.5pt"
    }
  }, [_vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('my-content', {
    attrs: {
      "val": _vm.contract.Adeputy
    },
    model: {
      value: (_vm.contract.Adeputy),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Adeputy", $$v)
      },
      expression: "contract.Adeputy"
    }
  })], 1), _vm._v(" "), _vm._m(86), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("签署日期：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AsignYear
    },
    model: {
      value: (_vm.contract.AsignYear),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AsignYear", $$v)
      },
      expression: "contract.AsignYear"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AsignMonth
    },
    model: {
      value: (_vm.contract.AsignMonth),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AsignMonth", $$v)
      },
      expression: "contract.AsignMonth"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.AsignDay
    },
    model: {
      value: (_vm.contract.AsignDay),
      callback: function($$v) {
        _vm.$set(_vm.contract, "AsignDay", $$v)
      },
      expression: "contract.AsignDay"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])], 1), _vm._v(" "), _vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _vm._m(89), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal"
    }
  }, [_vm._v("丙方：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Csign
    },
    model: {
      value: (_vm.contract.Csign),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Csign", $$v)
      },
      expression: "contract.Csign"
    }
  })], 1), _vm._v(" "), _vm._m(90), _vm._v(" "), _vm._m(91), _vm._v(" "), _vm._m(92), _vm._v(" "), _vm._m(93), _vm._v(" "), _vm._m(94), _vm._v(" "), _vm._m(95), _vm._v(" "), _vm._m(96), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('my-content', {
    attrs: {
      "val": _vm.contract.Cdeputy
    },
    model: {
      value: (_vm.contract.Cdeputy),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Cdeputy", $$v)
      },
      expression: "contract.Cdeputy"
    }
  })], 1), _vm._v(" "), _vm._m(97), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("签署日期：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.CsignYear
    },
    model: {
      value: (_vm.contract.CsignYear),
      callback: function($$v) {
        _vm.$set(_vm.contract, "CsignYear", $$v)
      },
      expression: "contract.CsignYear"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.CsignMonth
    },
    model: {
      value: (_vm.contract.CsignMonth),
      callback: function($$v) {
        _vm.$set(_vm.contract, "CsignMonth", $$v)
      },
      expression: "contract.CsignMonth"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.CsignDay
    },
    model: {
      value: (_vm.contract.CsignDay),
      callback: function($$v) {
        _vm.$set(_vm.contract, "CsignDay", $$v)
      },
      expression: "contract.CsignDay"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])], 1), _vm._v(" "), _vm._m(98)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "204pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal"
    }
  }, [_vm._v("乙方：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.Bsign
    },
    model: {
      value: (_vm.contract.Bsign),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Bsign", $$v)
      },
      expression: "contract.Bsign"
    }
  })], 1), _vm._v(" "), _vm._m(99), _vm._v(" "), _vm._m(100), _vm._v(" "), _vm._m(101), _vm._v(" "), _vm._m(102), _vm._v(" "), _vm._m(103), _vm._v(" "), _vm._m(104), _vm._v(" "), _vm._m(105), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('my-content', {
    attrs: {
      "val": _vm.contract.Bdeputy
    },
    model: {
      value: (_vm.contract.Bdeputy),
      callback: function($$v) {
        _vm.$set(_vm.contract, "Bdeputy", $$v)
      },
      expression: "contract.Bdeputy"
    }
  })], 1), _vm._v(" "), _vm._m(106), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("签署日期：")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BsignYear
    },
    model: {
      value: (_vm.contract.BsignYear),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BsignYear", $$v)
      },
      expression: "contract.BsignYear"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BsignMonth
    },
    model: {
      value: (_vm.contract.BsignMonth),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BsignMonth", $$v)
      },
      expression: "contract.BsignMonth"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('my-content', {
    attrs: {
      "val": _vm.contract.BsignDay
    },
    model: {
      value: (_vm.contract.BsignDay),
      callback: function($$v) {
        _vm.$set(_vm.contract, "BsignDay", $$v)
      },
      expression: "contract.BsignDay"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])], 1), _vm._v(" "), _vm._m(107)])])]), _vm._v(" "), _vm._m(108), _vm._v(" "), _vm._m(109), _vm._v(" "), _vm._m(110), _vm._v(" "), _vm._m(111), _vm._v(" "), _vm._m(112), _vm._v(" "), _vm._m(113), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("附件二：《大V店平台商品类别及服务费标准》")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.addDomain(0)
      }
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._m(114), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto"
    },
    attrs: {
      "data": _vm.contract.goodsStandard1,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('my-content', {
          attrs: {
            "val": scope.row.category
          },
          model: {
            value: (scope.row.category),
            callback: function($$v) {
              _vm.$set(scope.row, "category", $$v)
            },
            expression: "scope.row.category"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('my-content', {
          attrs: {
            "val": scope.row.brand
          },
          model: {
            value: (scope.row.brand),
            callback: function($$v) {
              _vm.$set(scope.row, "brand", $$v)
            },
            expression: "scope.row.brand"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "固定比例（%/单）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('my-content', {
          attrs: {
            "val": scope.row.ratio
          },
          model: {
            value: (scope.row.ratio),
            callback: function($$v) {
              _vm.$set(scope.row, "ratio", $$v)
            },
            expression: "scope.row.ratio"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.removeDelete(0, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("《大V店平台卖家商品类别及服务费标准》")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.addDomain(1)
      }
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._m(117), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto"
    },
    attrs: {
      "data": _vm.contract.goodsStandard2,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('my-content', {
          attrs: {
            "val": scope.row.category
          },
          model: {
            value: (scope.row.category),
            callback: function($$v) {
              _vm.$set(scope.row, "category", $$v)
            },
            expression: "scope.row.category"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('my-content', {
          attrs: {
            "val": scope.row.brand
          },
          model: {
            value: (scope.row.brand),
            callback: function($$v) {
              _vm.$set(scope.row, "brand", $$v)
            },
            expression: "scope.row.brand"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "固定比例（%/单）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('my-content', {
          attrs: {
            "val": scope.row.ratio
          },
          model: {
            value: (scope.row.ratio),
            callback: function($$v) {
              _vm.$set(scope.row, "ratio", $$v)
            },
            expression: "scope.row.ratio"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.removeDelete(1, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _vm._m(118), _vm._v(" "), _vm._m(119), _vm._v(" "), _vm._m(120), _vm._v(" "), _vm._m(121), _vm._v(" "), _vm._m(122), _vm._v(" "), _vm._m(123), _vm._v(" "), _vm._m(124), _vm._v(" "), _vm._m(125), _vm._v(" "), _vm._m(126), _vm._v(" "), _vm._m(127), _vm._v(" "), _vm._m(128), _vm._v(" "), _vm._m(129), _vm._v(" "), _vm._m(130), _vm._v(" "), _vm._m(131), _vm._v(" "), _vm._m(132), _vm._v(" "), _vm._m(133), _vm._v(" "), _vm._m(134), _vm._v(" "), _vm._m(135), _vm._v(" "), _vm._m(136), _vm._v(" "), _vm._m(137), _vm._v(" "), _vm._m(138), _vm._v(" "), _vm._m(139), _vm._v(" "), _vm._m(140), _vm._v(" "), _vm._m(141), _vm._v(" "), _vm._m(142), _vm._v(" "), _vm._m(143), _vm._v(" "), _vm._m(144), _vm._v(" "), _vm._m(145), _vm._v(" "), _vm._m(146), _vm._v(" "), _vm._m(147), _vm._v(" "), _vm._m(148), _vm._v(" "), _vm._m(149), _vm._v(" "), _vm._m(150), _vm._v(" "), _vm._m(151), _vm._v(" "), _vm._m(152), _vm._v(" "), _vm._m(153), _vm._v(" "), _vm._m(154), _vm._v(" "), _vm._m(155), _vm._v(" "), _vm._m(156), _vm._v(" "), _vm._m(157), _vm._v(" "), _vm._m(158), _vm._v(" "), _vm._m(159), _vm._v(" "), _vm._m(160), _vm._v(" "), _vm._m(161), _vm._v(" "), _vm._m(162), _vm._v(" "), _vm._m(163), _vm._v(" "), _vm._m(164), _vm._v(" "), _vm._m(165), _vm._v(" "), _vm._m(166), _vm._v(" "), _vm._m(167), _vm._v(" "), _vm._m(168)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0px 15px 0px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitContent()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.findEmpty()
      }
    }
  }, [_vm._v("定位未填")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.returnWindow()
      }
    }
  }, [_vm._v("返 回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "26pt",
      "font-weight": "bold"
    }
  }, [_vm._v("技术服务协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("北京果敢时代科技有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("与")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('br', {
    staticStyle: {
      "page-break-before": "always",
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "15pt",
      "font-weight": "bold"
    }
  }, [_vm._v("技术服务协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议由以下双方在北京")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("市朝阳区签署：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal"
    }
  }, [_vm._v("甲方：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("北京果敢时代科技有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（甲方和乙方以下各称为“一方”，合称为“双方”。）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("鉴于：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt 28.35pt",
      "text-align": "justify",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方及其关联公司是大V店电子商务平台、移动客户端及其他分销平台（以下简称“大V店平台”）的所有者和平台服务提供者。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt 28.35pt",
      "text-align": "justify",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方希望按照本协议的约定，在大V店平台上推广销售其商品或服务（包括但不限于发布商品或服务信息、与消费者达成交易、完成商品配送或以约定方式提供服务等）。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt 28.35pt",
      "text-align": "justify",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("丙方为乙方为保障双方合作履行，为乙方提供担保的在中华人民共和国境内完成注册的公司。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "28pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("双方经友好协商，达成协议内容如下：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("资质审核")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist1",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方根据大V店平台商家入驻规则和招商标准提交在大V店平台开展经营活动的必要信息和资质文件（具体内容详见附件一）。甲方仅在乙方符合甲方要求的商品品牌、类目和经营范围内许可乙方使用甲方服务。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方如变更所提交信息和资质文件，或新增商品品牌、类目或服务内容，应即时通知甲方并更新或补充相应信息和有效的资质文件，否则甲方有权拒绝继续提供服务。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方保证其信息和资质文件的真实性和有效性，并确保所提交信息和资质文件在乙方使用大V店平台服务期间均符合甲方不时修订的大V店平台商家入驻规则和招商标准。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("大V店平台服务")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist2",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("平台技术服务"), _c('br'), _vm._v("甲方为乙方和消费者提供交易平台，同时为乙方提供与大V店平台服务相关的技术服务，包括但不限于商品（服务）信息发布、平台内信息检索、订单管理、款项支付等技术服务。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("代收款服务"), _c('br'), _vm._v("消费者在大V店平台购买乙方商品或服务应支付的款项，乙方委托甲方代为收取。即：消费者按照大V店平台交易规则将相关款项通过各种支付渠道（包括但不限于网上银行、第三方支付机构等支付方式）支付至甲方收款账户，甲乙双方按照本协议约定进行款项结算。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("其他服务"), _c('br'), _vm._v("甲方有权根据乙方请求决定为乙方提供市场营销服务、仓储物流服务、客户服务、金融服务等增项服务，届时双方将另行签署协议或以其他书面方式确认。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("大V店平台规则")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist3",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方使用大V店平台服务，同意遵守甲方制订的"), _c('b', [_vm._v("《大V店平台商家管理规则》")]), _vm._v("及其它商家规范（以下简称“大V店平台规则”），大V店平台规则作为对本协议双方权利义务的补充，构成本协议的一部分。甲方有权根据需要不时制订或修改大V店平台规则，并在大V店平台上更新公示。乙方如不同意相关规则变更，须立即以正式书面方式告知甲方，甲方有权选择是否对乙方适用该规则变更或立即与乙方解约。如乙方继续使用大V店平台服务，视为乙方对大V店平台规则的无条件接受。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("商品销售")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist4",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方通过大V店平台向消费者销售商品或服务。乙方商品或服务应符合国家法律法规规定、大V店平台规则和招商标准。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应将其所销售商品或服务的图片、文字等信息按照甲方要求，上传至大V店平台。乙方经大V店平台确认后可以进行相关信息日常在线的维护，包括但不限于在售商品增减、商品信息调整、商品价格调整、日常客户服务等。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方通过大V店平台推广销售商品或服务，应严格遵守国家有关产品质量责任、消费者权益保护、广告发布和促销行为等法律法规的相关规定。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("商品交付")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist5",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("消费者在大V店平台提交订单并全额支付订单款项后【72】小时内，乙方负责将消费者购买的有关商品按照订单载明地址信息交付配送商，并通过大V店平台上传发货信息（包括但不限于配送方名称、配送单号信息等）。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应按甲方要求对商品进行二次包装，在包装中附带甲方要求的材料，包括但不限于发货单、商品票据等，但不得夹带任何未经甲方许可的资料、宣传单等资料。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方在配送过程中产生的包装费用、物流配送费用等均由乙方自行承担。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("商品定价")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist6",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方商品的销售价格由乙方自主决定，但乙方同意，甲方可按商品市场行情提供销售建议价。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方确认，乙方在大V店平台呈现的商品销售价格应为含税价格，且已包含乙方就该商品销售所提供的配送、售后服务等全部费用。乙方不得在向消费者配送商品或提供其他服务的过程中收取任何其他费用。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("商品质量")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist7",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("商品质量应符合下列要求：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）商品不存在危及人身、财产安全的危险，符合保障人体健康和人身、财产安全的相关国家、行业标准。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）具备商品应当具备的使用性能，对商品存在使用性能的瑕疵已作出说明。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）符合在商品或者其包装上注明采用的商品标准，与广告、商品说明、实物样品的质量状况相符合。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）商品不存在假冒伪劣、以次充好、失效变质等情况。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("商品或者商品包装上的标识真实，并符合下列要求：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）限期使用的商品，在显著位置标明生产日期和安全使用期或失效日期。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）商品成分说明或原料表，其中对于特殊成分应当予以相应的说明。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）使用不当容易造成商品本身损坏或者可能危及人身、财产安全的商品，有警示标志。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）国家有关标识的其他标准要求。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方提供的所有商品清洁整齐，包装完好，适宜销售，配送时包装不得出现任何污损。凡有保质期的商品如果保质期大于六个月的，乙方商品送达消费者订单指定收货地时其商品保质期距到期日的时限不得少于保质期规定的一半；如果商品保质期小于六个月，乙方商品送达消费者订单指定收货地时则不应少于其保质期的三分之二。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方提供商品不符合国家法律法规相关规定和前述商品质量要求，即视为不合格商品，消费者有权要求退款退货。乙方应当按照大V店平台的退货政策和流程为消费者办理退货。退货过程中产生的运输费用由乙方承担。如因乙方前述行为造成甲方或消费者任何损害（包括人身和财产损失）的，乙方应当承担全部赔偿责任。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("如乙方销售商品或服务存在下述情形的：(i)销售国家禁止流通，限制流通商品；(ii)提供非法服务；(iii)未经授权销售，销售侵权、假冒伪劣或有其他问题的商品；(iv)宣传图片或商品信息等违法侵权；(v)其他甲方认为不宜继续销售的情形，甲方可对该商品进行即时下架处理，并通知乙方提供相关相反证据，包括但不限于合法授权销售证明，乙方应立即提交。若乙方不能提供或经查前述情形属实的，甲方有权采取下列一项或多项措施：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）要求乙方承担大V店平台规则规定的惩罚金；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）要求乙方支付本协议生效到上述行为发生时为止乙方通过甲方销售商品总金额的10%作为违约金；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）要求乙方赔偿甲方因此遭受的全部损失；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）解除本协议。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("如因乙方提供商品存在瑕疵危及人身财产安全，或因涉及重大安全问题危及甲方名誉受损，或引起或可能引起较大规模投诉、举报或诉讼，甲方有权要求召回有关商品.乙方应按甲方要求在大V店平台或甲方指定其他媒介发布有关商品的召回信息，完成对召回商品的退货、换货、维修，并承担由此产生的所有费用。乙方同时应赔偿因此造成甲方及消费者的任何损失。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应根据国家法律法规、本协议约定、大V店平台规则及相关政策规定，为消费者提供乙方商品的“退货、换货、维修”等售后服务，包括但不限于：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）如消费者在收到商品前申请取消订单或拒绝签收商品，乙方同意甲方取消该笔订单并退还货款。该笔订单商品由乙方收回，因此产生的一切费用由乙方自行承担。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）如消费者在收到乙方所售商品之日起【15】日内要求无条件退换货的，乙方同意甲方接受退换货申请，并在乙方收到消费者退回商品后办理相应手续，因退换货产生的配送费用甲方应告知申请的消费者自行承担。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）如消费者在收到乙方所售商品后因商品违法、侵权、质量问题等要求退换货，乙方同意甲方接受退换货申请，并在收到消费者退回的商品后办理相应手续，因退换货产生的全部费用由乙方承担。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）如消费者要求维修商品，乙方应在收到消费者退回商品后的【30】日内将破损商品修复至令消费者满意且能合理使用的程度后重新配送给消费者。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（5）如消费者因乙方销售商品违法、侵权、质量问题等投诉、举报或提起诉讼，乙方负责处理解决并承担全部费用，保护甲方免予承担因此而产生的任何法律责任（包括任何赔偿或处罚）或声誉受损。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("先行赔付"), _c('br'), _vm._v("乙方了解并同意，如乙方未适当履行本协议规定的售后服务或未适当处理消费者投诉、举报或诉讼，甲方有权根据国家法律法规、本协议、大V店平台规则及相关政策规定，判断乙方是否应履行退款或赔付义务。如判定乙方应对消费者进行退款、支付违约金和/或赔偿款，甲方有权从乙方保证金中直接划扣相应金额支付给消费者，然后向乙方追偿或从任何甲方应付乙方款项中扣除。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）乙方应指派专人负责处理消费者提交或甲方转交的客户服务问题（统称“工单”），并将服务电话（内部接口专用）及工作邮件（内部接口专用）提供至甲方。乙方应在【48】小时内回复客服问题，对于超时回复，甲方有权按照大V店平台规则扣除乙方保证金。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）乙方回复内容中应包含对于该问题的解释、明确处理方案及事件说明，不能出现“正在查询/正在沟通”等无实质解决方案的回复，否则即视为延迟回复，具体以甲方的认定为准。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）乙方客服负责人联系方式如下，如有变更乙方应及时通知甲方，否则所产生的一切损失由乙方承担。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应就本协议项下甲方及甲方平台卖家向乙方提供的服务向甲方支付服务费。商品类别及服务费标准见"), _c('b', [_vm._v("附件二")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("付款方名称：MAMA HONG KONG LIMITED")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("开户银行：Silicon Valley Bank,Santa Clara")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("账号：3301326817")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Swift ID：SVBKUS6S")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "font-size": "8pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("对于乙方自甲方获取的任何补贴收入，包括但不限于各类优惠券、代金券、现金抵用券补贴，乙方应根据甲方要求向甲方开具合法有效的发票。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议终止时（无论任何原因），甲方有权继续留存最后一期应付乙方款项【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于商品违法、侵权、质量缺陷、商品宣传违规等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲乙双方可就最后一期应付乙方款项进行结算。否则，甲方有权直接从最后一笔结算款项中扣除对应款项，最后一笔结算款项不足弥补甲方损失部分，乙方应继续承担相应赔偿责任。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n                   如乙方保证金额度调整或出现任何保证金被扣减情形，导致乙方保证金不足约定金额时，乙方同意甲方自应付乙方的任何款项中直接扣除差额，如甲方应付乙方款项不足弥补保证金差额，乙方应当于收到甲方通知之日起【10】日内将保证金补足。\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方保证金银行账户信息如下：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("户名：【北京果敢时代科技有限公司】")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("开户行：【招商银行股份有限公司北京望京支行】")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("账号：【110915262610114】")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方可在以下情形发生时，处置保证金：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）如乙方违反国家法律法规、本协议、大V店平台规则或其他政策规定，应向消费者退还货款、支付违约金和/或赔偿款的，甲方有权直接划扣保证金用于代乙方向消费者退还货款、支付违约金和/或赔偿款。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）如乙方违反国家法律法规、本协议、大V店平台规则或其他政策规定，致使甲方及/或其关联公司权益受损（包括但不限于被行政处罚、被判决侵权、商誉受损等），甲方有权划扣保证金中的相应金额至甲方账户作为违约金和/或赔偿款。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）如乙方违反本协议或大V店平台规则，根据本协议或大V店平台规则应当向甲方支付惩罚金、违约金和/或赔偿款，甲方有权划扣保证金中的相应金额至甲方账户作为惩罚金、违约金和/或赔偿款。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）如乙方违反其与甲方或其关联公司的其他协议规定造成甲方或其关联公司损失或应支付违约金，乙方同意甲方可基于该协议规定直接划扣保证金中的相应金额。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（5）其他甲方有合法合理理由可处置保证金的情况。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议履行期间，保证金的支配、使用权均归属于甲方。在乙方解散、清算、破产时，甲方享有对保证金的优先受偿权。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议终止时（无论任何原因），甲方有权继续留存保证金【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于商品违法、侵权、质量缺陷、商品宣传违规等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲方将保证金余额无息退还乙方。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("知识产权")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist11",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("与商品相关的专利、商标、名称、特有标识、装潢、技术秘密等均属于其权利人所有。乙方保证其已按照法律规定或者合同约定获得了通过大V店平台销售商品或服务的权利或许可，该等权利或许可不与任何排他性权利相冲突，否则乙方应赔偿甲方因此而产生的任何经济损失。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n                   乙方在此不可撤销地免费授权甲方 (并许可甲方对该权利进行再授权)，以推广乙方商品为目的，全部或部分地摘录、改编、翻译、复制、发布、展示或以其它任何合理方式使用乙方提供给甲方或其在大V店平台展示的任何信息和资料（包括但不限于商品商标、logo、商品信息、宣传资料、订单信息等)。\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("乙方保证和承诺")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist12",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("除严格遵守本协议和大V店平台规则其它规定外，乙方保证和承诺：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）乙方具有签订和履行本协议所需的所有合法资格、资质和能力，包括应持有中国法律法规所要求的一切证明、批准、许可和其他任何证明文件，而且应为商品的生产商或授权经销商。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）乙方在大V店平台销售的商品来源正当合法，均为全新正品行货；乙方对其商品享有唯一的合法的所有权，并且商品在本协议项下的推广和销售未侵犯任何第三方的权利，包括但不限于第三方的知识产权。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）乙方在大V店平台上销售的同款商品的销售价格不高于其提供给任何其他渠道或采购方的价格。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("甲方免责")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist13",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("不论在何种情况下，甲方均不对由于Internet连接故障、计算机系统故障、通讯故障、电力故障、电脑病毒、黑客入侵、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争等不可抗力事件而造成的不能服务或延迟服务承担责任。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("大V店平台仅作为乙方寻找交易对象，就商品和服务的交易进行协商，以及获取各类与交易相关服务的平台。本协议的签署并不意味着甲方成为乙方在大V店平台上与第三方所进行交易的参与者，对交易行为甲方仅提供技术服务，不对乙方行为的合法性、有效性及商品的真实性、合法性和有效性作任何明示或暗示的担保。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("保密")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist14",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("任何一方均应对本协议内容，以及依据本协议而获得的对方的保密或专有信息（包括但不限于，与对方的技术、客户、商业计划、营销活动和财务有关的所有信息）（统称为“保密信息”）严格保密，并且不得用于本协议以外目的，否则应对因此给对方造成的损失承担赔偿责任。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("未经甲方及/或其关联公司同意，乙方不得使用甲方及/或其关联公司的任何商标、服务标识、品牌或其他知识产权，不得发布有关甲方及/或其关联公司或者本合同的任何新闻稿或其他公开文件，或在任何宣传资料中提及甲方及/或其他关联公司。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("任何一方可在另一方严重违反本协议且收到守约方书面通知后十五(15)个工作日内未予以纠正时，书面通知另一方，立即终止本协议；任何一方可以经提前六十天向另一方发出书面通知而无因终止协议，前提是乙方已经履行完毕其在本协议终止前已接受的订单。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("协议终止后续事项的处理")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）自本协议终止之日起，甲方将关闭乙方在大V店平台上的“用户名”账户权限，并对乙方商品和服务内容全部下架，乙方将无法再通过该账户进行任何形式的操作且大V店平台不再显示任何乙方商品信息。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）本协议终止后，甲方有权保留乙方的注册信息及交易行为记录等数据，但甲方没有为乙方保留这些数据的义务，亦不承担在协议终止后向乙方或第三方转发任何未阅读或未发送的信息的义务，也不就协议终止向乙方或任何第三方承担责任，但法律另有规定的除外。")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）本协议终止并不免除乙方依据本协议应向客户承担的商品质量责任和售后服务义务；如本协议终止后，因乙方商品质量问题或售后服务问题而导致甲方或其他任何第三方人身或财产损失的，乙方仍应承担全部赔偿责任。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("违约责任")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist16",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议履行过程中，乙方如违反国家法律法规、本协议、大V店平台规则或其他政策任何规定，或侵犯任何第三方（包括但不限于消费者、知识产权权利人或商品/服务的实际使用者）合法权益，除根据本协议和/或大V店平台规则向甲方支付惩罚金、违约金外，还应赔偿甲方因此遭受的全部损失，包括但不限于：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）甲方被判决须向任何第三方支付的违约金或赔偿额；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）甲方被执行行政处罚的金额；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）甲方代乙方向消费者支付的退款、违约金或赔偿额；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）甲方支付的合理律师费用、消除影响所支出的必要费用。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议履行过程中，乙方保证乙方股东、实际控制人、董事、经理、业务负责人、雇员、代理人、受托人等（以下称“乙方代表”）均严格履行本协议规定及大V店平台之规则，并遵守本协议附件三《大V店合作伙伴行为准则》，乙方代表违反本协议任何内容的行为视为乙方违约行为，乙方应对此承担全部法律责任。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议履行过程中，如果乙方不能承担履行义务或者不能完全承担履行义务的，丙方承担担保责任。丙方的担保期至合同届满后三个月终止。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("其他")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist17",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议受中华人民共和国法律管辖。对于因本协议而产生的任何争议，双方均应努力通过友好协商的方式进行解决。如无法就争议解决达成一致，任何一方可将争议提交北京的中国国际经济贸易仲裁委员会，按其当时有效的仲裁规则进行仲裁，仲裁语言为中文。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议一方未经另一方事先书面同意不得将其本协议项下的权利和义务全部或部分转让给任何第三方。尽管有前述规定，乙方同意，甲方可将本协议（或其在本协议项下的任何权利或义务）转让给其关联公司，或当发生合并、重组、出售全部或重要资产或类似交易时转让给其后续公司。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议无论因任何原因终止，除协议中已有规定外，商品质量、售后服务、知识产权、保密、保证和承诺、违约责任条款在协议终止后将继续有效。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议内容包括协议正文、附件、补充协议以及甲方不时修订的大V店平台规则。任何对本协议或大V店平台规则的修订一经生效即构成协议各方权利义务的补充，并成为本协议的一部分。本协议由中文和英文两种语言书写，如有歧义，以中文为主。本协议经双方授权代表签署并加盖双方公章或合同章后生效，一式三份，甲方、乙方、丙方各执一份，具有同等效力。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v("[")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v("以下部分无正文")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v("]")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal"
    }
  }, [_vm._v("甲方：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("北京果敢时代科技有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("授权代表签字：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("授权代表签字：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("授权代表签字：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('br', {
    staticStyle: {
      "page-break-before": "always",
      "clear": "both"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("附件一：乙方资质证明文件清单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "margin": "0 auto",
      "width": "397.45pt"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt",
      "font-weight": "bold"
    }
  }, [_vm._v("文件名称")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt",
      "font-weight": "bold"
    }
  }, [_vm._v("备注")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("商家的主体资格证明文件")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("商家的税务登记证或最近一期缴税证明文件")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("法定代表人的身份证件复印件")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("海外银行账户开户证明或者对账单")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("品牌的商标注册证明文件")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("合同对方为生产商或有授权的经销商时适用")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("品牌的商标所有人出具的销售授权书")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("若该商家不是品牌的商标所有权人，（合同对方为有授权的经销商时适用）")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("从品牌方至商家的完整进货凭证和授权书")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("若该商家不是品牌的商标所有权人")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("近半年内的中华人民共和国进口货物报关单复印件（化妆品可放宽至近两年内）")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("若商品为母婴用品、居家日用品、食品或化妆品（合同对方为生产商或有授权的经销商时适用）")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("近半年内的商品出入境检验检疫合格证明复印件（化妆品可放宽至近两年内）")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("若商品为食品或化妆品（合同对方为生产商或有授权的经销商时适用）")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "9pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "9pt"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "174.7pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("质检报告")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "180.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("（合同对方为生产商或有授权的经销商时适用）")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Book Antiqua'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('br', {
    staticStyle: {
      "page-break-before": "always",
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background-color": "#ffffff",
      "line-height": "15.75pt",
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background-color": "#ffffff",
      "line-height": "15.75pt",
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background-color": "#ffffff",
      "line-height": "15.75pt",
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background-color": "#ffffff",
      "line-height": "15.75pt",
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('br', {
    staticStyle: {
      "page-break-before": "always",
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("附件三：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "15.6pt 0pt 0pt",
      "orphans": "0",
      "text-align": "center",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "16pt",
      "font-weight": "bold"
    }
  }, [_vm._v("大V店合作伙伴行为准则")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n        本大V店合作伙伴行为准则（“本准则”）作为大V店（定义见下）与合作方之间的协议（“本协议”）的附件存在。签署合作协议即视为合作方业已仔细阅读了本准则的全部内容、同意遵守本准则的全部条款并在任何违反本准则条款的行为发生时愿意按照合作方协议及本准则的规定承担责任。\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n        在本准则中，合作方指签署本协议的合作方（“合作方”），按照语境亦得包括其关联方、特殊利益实体、股东、经理、董事、管理人员、员工、承包商、代理或代表（按照语境亦得称为“合作方成员”）；大V店指签署本协议的大V店的运营实体（“大V店”），按照语境亦得包括其关联方、特殊利益实体、股东、经理、董事、管理人员、员工、承包商、代理或代表（按照语境亦得称为“大V店成员”）。\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("作为合作方与大V店进行业务往来必须遵守本准则中的所有规定。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n        任何对本准则的违反有可能招致有权的执法机关对合作方的行为展开反商业贿赂调查或其他行动，大V店有义务按照法律的规定配合该等调查或行动。大V店配合该等调查或行动时有义务向有权的执法机关披露和报告其知悉的所有相关情况。任何该等披露和报告不得视为大V店对任何协议约定的保密义务的违反。大V店也不因该等披露和报告而向合作方或任何第三方承担任何形式的责任。\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("遵守法规")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("合作方应保证自己及其成员熟悉并充分遵守所有与合作方履行本协议事项相关的和可适用于本协议下交易的所有关于反腐败、反贿赂和利益冲突的法律法规，包括但不限于《刑法》、《反不正当竞争法》、《公司法》、《关于禁止商业贿赂行为的暂行规定》以及适用的其他法律法规和任何其他国家或司法区域的相关法律法规。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "2",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("补偿")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("如果合作方及其成员因违反适用的反商业贿赂法律、与利益冲突有关的法律、美国反海外贿赂法、英国反贿赂法或任何其他适用法律而遭到索赔、指控、诉讼，或被发现有此类行为的，合作方应保护大V店及其成员免受任何和一切可能或实际发生的索赔、诉讼，并补偿其因相关罚金、损害赔偿、补偿等而产生的任何支出（包括诉前调查、专家费用、律师费）以及任何一切已付或需付的款项。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "3",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("报告")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("如知悉任何违反本准则的情形，合作方应采取适当方式保留证据，并立即通知大V店。大V店鼓励合作方报告前述情形，并保证合作方不因报告而遭受不公平的待遇，但捏造事实、企图通过报告诬陷他人、损害他人名誉的除外。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "4",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("禁止提供不正当利益")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n        合作方不得向大V店及其成员提供或许诺提供、大V店及其成员亦不得要求合作方向其提供或许诺提供任何形式的不正当利益，包括但不限于现金、银行存单、支票、旅行支票、购物卡、礼券、打折卡、会员卡等现金等价物和有价证券、借款、实物、费用报销、服务、礼品和招待或任何其他形式的便利或利益。\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "5",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("礼品政策")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("5.1    在满足本准则第5.2条规定的条件时，合作方可以向大V店及其成员提供礼品，大V店及其成员亦可接受该等礼品。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("5.2    合作方向大V店及其成员提供礼品应当满足以下第5.2.1至第5.2.4条规定的全部条件：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("5.2.1  合作方不意图并且在事实上也不会通过提供礼品获得任何不正当利益")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("5.2.2  礼品只能以实物形式提供。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("5.2.3  礼品应当属于以下三类中的某一类：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 60pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "-18pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v("a)")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("       ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("按照交易当地的风俗习惯体现一般商业礼仪的礼品，如中秋节提供的月饼；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 60pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "-18pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v("b)")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("       ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("为市场推广目的提供的、带有合作方商标或标识的广告礼品或纪念品；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 60pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "-18pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v("c)")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("       ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("体现一般商业礼仪的糖果、饮料、食品、水果、鲜花等；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("5.2.4  单次提供的礼品的公允市场价值不得超过每人【三百元】人民币或等值外币。合作方在一个自然年度内向同一大V店成员两次或两次以上提供礼品的，各次该等礼品的公允市场价值累计不得超过每人【六百元】人民币或等值外币。本第5.2.4条规定的金额标准可以由公司按照需要进行调整，以提供或接受招待当时实行的标准为准。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("5.3  大V店有权对某一礼品是否符合本准则第5.2条的规定进行判断，但无义务就针对某一礼品的判断向合作方作出说明或解释。任何不符合本准则第5.2条规定的礼品均有可能被大V店视为贿赂，任何该等贿赂的信息将被记入大V店的合作方管理记录并将作为合作方的不良记录在将来选择合作方时成为考虑因素。大V店无义务退回任何其认为属于贿赂的礼品，未退回礼品不得被视为大V店及其成员对该等礼品的接受，亦不得视为其符合本准则第5.2条的规定。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "6",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("招待政策")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("6.1    招待指向大V店成员提供的，由合作方、合作方成员或其指定的第三方支付费用的活动。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("6.2    在满足本准则第6.3条规定的条件时，合作方可以向大V店成员提供招待，大V店成员亦可接受该等招待。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("6.3    合作方向大V店成员提供招待应当满足以下第6.3.1至第6.3.5条规定的全部条件：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("6.3.1  合作方不意图并且在事实上也不会通过提供招待获得任何不正当利益，本条的不正当利益包括但不限于按照一般的商业判断本不应属于合作方的交易机会、更优惠的交易条件、对竞争对手的优势等。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("6.3.2  招待标准不应当超出一般的商业习惯。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("6.3.3  招待应当由合作方人员全程陪同。未能由合作方人员全程陪同的招待将被视为本准则第5条中规定的礼品。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("6.3.4  向大V店成员提供的招待的价值不得超过每人每次【三百元】人民币或等值外币。合作方在一个自然年度内向同一大V店成员两次或两次以上提供招待的，各次该等招待的价值累计不得超过每人【六百元】人民币或等值外币。本第6.3.4条规定的金额标准可以由公司按照需要进行调整，以提供或接受招待当时实行的标准为准。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("6.3.5  任何招待活动应当是符合当地法律法规规定的合法活动且应当符合当地的一般社会道德标准。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "7",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("无贿赂承诺")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("截至本协议签署时止，合作方及其成员不曾有违反本准则任何规定的行为。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "8",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("利益冲突")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("利益冲突包括合作方或其股东、成员、经理、董事、管理人员、员工或者其近亲属、特殊利益关系人等与大V店或其股东、成员、经理、董事、管理人员、员工或者其近亲属、特殊利益关系人等之间存在兼职/雇佣关系、家庭关系（血缘或非血缘）、密切的私人关系、投资关系（股权或非股权）或其为同一人或实体等的情形。在此情形下，涉及利益冲突的个人或实体可能不能按照合理的商业判断标准对一项交易作出判断。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("不论实际的利益冲突是否存在，合作方均有义务在交易磋商的开始阶段并最晚不晚于交易达成前向大V店披露任何可能的利益冲突。判断是否存在实际的利益冲突的权力在大V店而不在合作方。对于存在可能的利益冲突，但按照大V店的判断不存在实际的利益冲突的交易，大V店仍然可以批准，前提是该等批准符合适用法律法规的规定，且其已经按照该等法律法规的规定履行了法律要求的各项程序性义务（如有）。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("如果存在合作方知道或者应当知道的可能的利益冲突但合作方未能按照本准则的规定进行披露的，大V店有权在知悉该等可能的利益冲突后，在无须对是否存在实际的利益冲突进行调查的情况下立即终止交易磋商或解除协议。在此情形下，大V店无需就终止交易磋商或解除协议向合作方承担任何责任，合作方应当对大V店因此遭受的所有损失进行赔偿，包括但不限于交易磋商的成本、准备履行交易的费用及因利益冲突而给大V店造成的损失等。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("合作方保证，其已经完全理解了前述有关利益冲突的规定并已经且将继续按照该等规定履行其披露义务，并承担因未能按照前述规定进行披露所引起的任何责任。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "9",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 14.93pt",
      "padding-left": "6.37pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("合作方成员的责任")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21.2pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本准则对合作方成员亦同样适用，合作方有义务使其成员知晓并遵守本准则。合作方同意向大V店承担因合作方成员未能遵守本准则而引起的责任。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "10",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold",
      "margin": "7.8pt 0pt 0pt 21.3pt",
      "text-indent": "0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("记录、调查和审计")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("10.1    合作方按照本准则第5.1条的规定向大V店及其成员提供礼品的，或按照第6.2条的规定提供招待的，合作方应当保留提供该等礼品和招待的完整记录并在大V店要求时向其提供该等记录。任何未能保留记录或在大V店要求时未能提供该等记录的礼品和招待将被视为对本准则第4条的违反。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("10.2    合作方应就对本准则的遵守情形，保存必要、准确的账簿和记录，并应大V店的要求提供合理的证明和信息披露。合作方应充分配合大V店对可能违反本准则行为的任何调查。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "orphans": "0",
      "text-align": "justify",
      "text-indent": "21pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("10.3    合作方应就其履行本准则的行为保存准确的账簿和记录（包括一切与提供服务有关的收付细节），并应要求向大V店或大V店聘请的审计师提供该等账簿和记录。合作方应充分配合可能实施的一切该等审计工作。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9d92896"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplier/contract/edit/contract_3.vue
// module id = 576
// module chunks = 0